import PageConfirmEmail from './components/ConfirmEmail';

export default PageConfirmEmail;


// WEBPACK FOOTER //
// ./routes/confirm-email/index.js